import ContinuePage from "@components/ContinuePage"

export default function HairstyleStyleProfilePage() {
  return <ContinuePage emoji="✨" translationKey="styleProfileHairstyle" />
}
